import React, { useCallback, useEffect, useState } from 'react'
import { Header, Page } from 'components'
import { Button, Card, CardContent, Grid, TextField, Typography } from '@material-ui/core'
import useStyles from './styles'
import useRouter from 'utils/useRouter'
import { useAnuncioService } from 'hooks/useAnuncioService'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'
import moment from 'moment'
import localization from 'moment/locale/pt-br'

export const Anuncios = () => {
  const { verificarPermissao } = useAuth()
  const router = useRouter()
  const classes = useStyles()
  moment.locale('pt-br', localization)
  const anuncioService = useAnuncioService()
  const [anuncios, setAnuncios] = useState([])
  const [processandoAnuncio, setProcessandoAnuncio] = useState(false)
  const [limit, setLimit] = useState(2)

  const fetchListarAnuncios = useCallback(async () => {
    const response = await anuncioService.listarAnunciosAsync(limit, setProcessandoAnuncio)
    setAnuncios(response)
  }, [limit])

  useEffect(() => {
    fetchListarAnuncios()
  }, [limit])

  const handleOpenAnuncios = () => {
    setLimit(limit + 2)
  }

  const handleCadastrarAnuncios = () => {
    router.history.push('/anuncio/cadastraranuncio')
  }

  const handleDetalhesAnuncios = (id) => {
    router.history.push(`/anuncio/detalhes/${id}`)
  }

  return (
    <CardContent style={{ width: '100%' }}>
      <Grid className={classes.fieldGroup} alignItems="center" spacing={0} container justifyContent="space-between">
        {verificarPermissao([constants.PERMISSOES.CADASTRAR_ANUNCIO]) ? (
          <Grid container item md={12} sm={12} xs={12} justifyContent="space-between">
            <Grid item md={12} sm={12} xs={12} className={classes.cadastrarBtn}>
              <Button onClick={handleCadastrarAnuncios} color="primary" variant="contained">
                Cadastrar Anúncio
              </Button>
            </Grid>
          </Grid>
        ) : null}
        {anuncios.length
          ? anuncios.map((anuncio, index) => (
              <Grid key={index} container item md={12} sm={12} xs={12} justifyContent="space-between" className={classes.anuncio}>
                <Grid className={classes.item} container item md={12} sm={12} xs={12} justifyContent="space-between">
                  <Typography className={classes.text} variant="h4">
                    {`${anuncio?.titulo}`}
                  </Typography>

                  <Typography className={classes.text} variant="h6">
                    Data do anúncio: {`${moment(anuncio?.createdAt).format('LLLL')}`}
                  </Typography>
                </Grid>
                <Grid className={classes.item} item md={12} sm={12} xs={12}>
                  <Typography className={classes.text}>
                    <b>Interessados: </b>
                    {anuncio?.destino === 'Orgão' ? anuncio.orgaos.map((orgao) => `${orgao.nome} - ${orgao.sigla}`).join(', ') : null}
                    {anuncio?.destino === 'Regional' ? anuncio.regionais.map((regional) => `${regional.nome} - ${regional.sigla}`).join(', ') : null}
                    {anuncio?.destino === 'Divisão' ? anuncio.divisoes.map((divisao) => `${divisao.nome} - ${divisao.sigla}`).join(', ') : null}
                    {anuncio?.destino === 'Setor' ? anuncio.setores.map((setor) => `${setor.nome} - ${setor.sigla}`).join(', ') : null}
                  </Typography>
                </Grid>
                <Grid className={classes.item} item md={12} sm={12} xs={12}>
                  <Typography className={classes.text} variant="body2">
                    {' '}
                    {anuncio?.resumo || null}{' '}
                  </Typography>
                </Grid>
                <Grid className={classes.detalhes} item md={12} sm={12} xs={12}>
                  <Button className={classes.detalhesBtn} onClick={() => handleDetalhesAnuncios(anuncio.id)}>
                    VER DETALHES
                  </Button>
                </Grid>
              </Grid>
            ))
          : null}
        <Grid container>
          <Button onClick={handleOpenAnuncios} color="primary" fullWidth variant="contained">
            Ver mais
          </Button>
        </Grid>
      </Grid>
    </CardContent>
  )
}
